/**
 * Map-pin icon shaped like a teardrop with a stylized Kentucky outline inside.
 * The Kentucky path is a hand-simplified silhouette — readable at small sizes
 * without trying to capture every panhandle wiggle.
 */
export default function KentuckyPin({ size = 14, color = "#9CC279", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
    >
      {/* Pin outline */}
      <path
        d="M12 2 C 7.6 2, 4 5.4, 4 9.6 C 4 14.2, 9 19, 12 22 C 15 19, 20 14.2, 20 9.6 C 20 5.4, 16.4 2, 12 2 Z"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
      />
      {/* Inner circle — the lens the state sits inside */}
      <circle cx="12" cy="9.6" r="4.6" fill="rgba(13,17,12,0.85)" stroke={color} strokeWidth="0.6" />
      {/*
        Stylized Kentucky silhouette. Roughly: a long horizontal lozenge with the
        characteristic eastern jut and the south-western tip ('Jackson Purchase').
        Path is scaled to fit inside the lens.
      */}
      <path
        d="M7.8 9.1
           L 9.6 8.7
           L 11.2 8.3
           L 13.1 8.5
           L 14.6 8.4
           L 15.7 8.9
           L 16.0 9.7
           L 15.2 10.3
           L 13.6 10.6
           L 11.4 10.7
           L 9.5 10.6
           L 8.2 10.3
           L 7.7 9.7
           Z"
        fill={color}
      />
    </svg>
  );
}
